export default "__VITE_ASSET__DkigwwqO__"